exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selectLogOut {\r\n    color: rgba(255, 255, 255, 0.92);\r\n    background-color: rgba(0, 0, 0, 0.07);\r\n    box-shadow: none;\r\n    border: none;\r\n    outline: none;\r\n    -webkit-box-shadow: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.djiv-user-dropdown {\r\n    display: inline-block;\r\n    z-index: 1;\r\n}\r\n\r\n.djiv-user-dropdown i {\r\n    height: 20px;\r\n}\r\n\r\n.dropdown-menu {\r\n    min-width: 9.6rem !important;\r\n}\r\n\r\n.showMenu {\r\n    display: block;\r\n    background-color: #1553a5;\r\n    color: rgba(255, 255, 255, 0.92);\r\n    border-radius: none;\r\n}\r\n\r\n.user-item {\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: 1.52;\r\n    letter-spacing: 0.2px;\r\n    background-color: #1553a5;\r\n    padding-left: 10px;\r\n}\r\n\r\n.user-item:hover {\r\n    background-color: #007bff;\r\n}\r\n\r\n@media (max-width: 576px) {\r\n    .dropdown-menu {\r\n        left: unset;\r\n        right: 0;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Repositories/wfa3/SupplierPortal/app/src/app/shared/components/djiv-user-menu/djiv-user-menu.component.css
// module id = ../../../../../src/app/shared/components/djiv-user-menu/djiv-user-menu.component.css
// module chunks = main